:host {
  font-family: var(--ls-font-family);
  position: relative;
  display: block;
  min-width: 600px;
}

.path {
  fill: none;
  stroke: var(--ls-primary-color);
  stroke-width: 3px;
}

.line {
  stroke: #e4e4e7;
  stroke-width: 1;
  shape-rendering: crispEdges;
}

.line:first-child {
  stroke: #71717a;
}

.stop {
  fill: var(--ls-primary-color);
  stroke: none;
}

.fake {
  fill: transparent;
  stroke: none;
}

.passed {
  fill: #fff;
  stroke: var(--ls-primary-color);
  stroke-width: 1px;
}

.overlay {
  fill: none;
  stroke: none;
  pointer-events: all;
}

.loading,
.error {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
  background-color: white;
}

.focusLine {
  fill: none;
  stroke: var(--ls-accent-color);
  stroke-width: 1px;
}

.focusCircle {
  fill: var(--ls-accent-color);
}

.focus_text_container rect {
  fill: rgba(0, 0, 0, 0.1);
}

.focus_text_container text {
  fill: var(--ls-font-primary-color);
  font-family: var(--ls-font-family);
}

.axis {
  font-family: var(--ls-font-family);
}

.axis path,
.axis line {
  fill: none;
  stroke: #71717a;
  stroke-width: 1;
  shape-rendering: crispEdges;
}

.disconnected svg {
  display: none;
}

.disconnected::after {
  content: "Disconnected";
  position: absolute;
  width: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  height: 100%;
  font-size: 2.5rem;
  color: #71717a;
  text-transform: uppercase;
  left: 0;
  top: 0;
  text-align: center;
  border: 1px solid #71717a;
  background-color: rgba(255, 255, 255, 1);
}
